import styled from "styled-components";
import { IoIosLogOut } from "react-icons/io";

export default function LogoutButton() {
    function logout() {
        localStorage.removeItem('passenger')
        window.location.reload()
    }
    return (
        <Button onClick={logout}>
            <IoIosLogOut size={20}/>
        </Button>
    )
}

const Button = styled.button`
background-color: transparent;
border: 2px solid ${props => props.theme.dark};
color: ${props => props.theme.primary};
width: 35px;
height: 35px;
display: flex;
align-items: center;
justify-content: center;
border-radius: 50%;
font-size: 16px;
cursor: pointer;
transition: all 0.3s ease;
position: fixed;
top: 10px;
right: 10px;
&:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 10px ${props => props.theme.blackTransparent};
}
`